import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TecladoNumerico from '../components/kiosko/TecladoNumerico';
import BotonKiosko from '../components/kiosko/BotonKiosko';
import MensajeModal from '../components/kiosko/MensajeModal';
import './Kiosko.css';

export default function PaginaKiosko() {
    const [code, setCode] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [showError, setShowError] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleKeyPress = (val) => {
        if (code.length < 8) {
            setCode(prev => prev + val);
        }
    };

    const handleDelete = () => {
        setCode(prev => prev.slice(0, -1));
    };

    const handleClear = () => {
        setCode('');
    };

    const handleIngresar = async () => {
        if (!code) {
            setErrorMsg('Por favor ingresa tu código de empleado.');
            setShowError(true);
            return;
        }

        const { success, message, user } = await login(code);
        if (success) {
            // El dispatcher de App.jsx se encargará de la redirección al "/"
            navigate('/');
        } else {
            setErrorMsg(message || 'Código no válido. Intenta de nuevo.');
            setShowError(true);
            setCode('');
        }
    };

    return (
        <div className="kiosko-container animate-fade">
            <div className="kiosko-card">
                <header className="kiosko-header">
                    <div className="kiosko-logo" style={{ color: 'var(--color-primary)' }}>⚖️ ALINEA</div>
                    <h1>Bienvenido a Planta</h1>
                    <p>Ingresa tu código para reportar bienestar</p>
                </header>

                <main className="kiosko-main">
                    <div className="display-container">
                        <div className={`code-display ${code ? 'active' : ''}`}>
                            {code || '--------'}
                        </div>
                    </div>

                    <div className="keypad-wrapper">
                        <TecladoNumerico
                            onKeyPress={handleKeyPress}
                            onClear={handleDelete}
                            onEnter={handleIngresar}
                        />
                    </div>

                    <div className="action-wrapper">
                        <BotonKiosko
                            texto="INGRESAR AHORA"
                            color="blue"
                            tamano="enorme"
                            onClick={handleIngresar}
                        />
                    </div>
                </main>
            </div>

            <MensajeModal
                visible={showError}
                titulo="¡Ops! Algo salió mal"
                mensaje={errorMsg}
                tipo="error"
                onConfirm={() => setShowError(false)}
            />
        </div>
    );
}

